import { Box, Flex, FlexProps, Icon, Text, VStack } from "@chakra-ui/react";
import { ImLab } from "react-icons/im";
import { useLeftNav } from "./LeftNavContext";
import { NavItemElement, NavItemIconType } from "./NavItem";

export type NavGroupElement = React.ReactElement<Props>;
type NavItemNode = NavItemElement | boolean | undefined | null;
type Props = {
  kind?: "NavGroupElement";
  label?: string;
  trailIcon?: NavItemIconType;
  children: NavItemNode | NavItemNode[];
  level?: number;
} & FlexProps;

export function NavGroup({
  label,
  children,
  trailIcon,
  level,
  ...props
}: Props) {
  const { mode } = useLeftNav();
  return (
    <Flex
      direction="column"
      as="li"
      align="flex-start"
      width="100%"
      padding="0"
      justifyContent="center"
      {...props}
    >
      {mode === "full" && label && (
        <Box fontSize="sm" display="flex" alignItems="center" height="2.5rem">
          <Flex alignItems="center" gap={2}>
            <Text fontSize="sm" color="gray.700">
              {label}
            </Text>
            {trailIcon && (
              <Icon
                w="5"
                h="5"
                as={ImLab}
                color="primary.500"
                aria-hidden="true"
              />
            )}
          </Flex>
        </Box>
      )}
      <VStack
        align="flex-start"
        as="ul"
        margin="0"
        width="100%"
        aria-label={label}
      >
        {children}
      </VStack>
    </Flex>
  );
}
